<div class="pb-6">
  <h2 class="fw-bolder text-dark">{{ "WIZARD.SHOP.COMPANY_INFORMATION" | translate }}</h2>
<!--  <div class="text-gray-400 fw-bold fs-6">-->
<!--    {{ "WIZARD.ACCOUNT_TYPE_HELP" | translate }}-->
<!--    <a href="#" class="link-primary fw-bolder">{{ "WIZARD.ACCOUNT_TYPE_HELP_PAGE" | translate }}</a>-->
<!--  </div>-->
</div>
<app-validation-errors [backendValidationErrorsList]="backendValidationErrorsList"></app-validation-errors>
<app-data-form
  (formChangesEmitter)="onFormChanged($event)"
  [defaultValues]="defaultValues"
  [disableForm]="isFormDisabled"
></app-data-form>
<div class="separator border-gray-200"></div>
<div class="d-flex flex-stack pt-6">
  <div class="mr-2">
    <button
      type="button"
      class="btn btn-lg btn-light-primary me-3"
      [disabled]="isFormDisabled"
      (click)="onBackClick()"
    >
      <span
        [inlineSVG]="'./assets/media/icons/duotune/arrows/arr063.svg'"
        class="svg-icon svg-icon-4 me-1"
      ></span>
      {{'WIZARD.BACK'|translate}}
    </button>
  </div>
  <div>
    <button
      type="button"
      class="btn btn-lg btn-primary"
      [disabled]="(isFormValid$ | async) === false || isFormDisabled"
      (click)="onCompleteClick()"
    >
      <span class="indicator-label">
          {{'WIZARD.FINISH' | translate}}
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr085.svg'"
          class="svg-icon svg-icon-3 ms-2 me-0"
        ></span>
      </span>
    </button>
  </div>
</div>
